<div [formGroup]="group" class="radio-group-container">
  <label class="group-label">{{ config.label }}</label>
  <mat-radio-group 
    [formControlName]="config.name"
    aria-label="Selecione uma opção"
    class="options-container" 
    [disabled]="isDisabled">
      <mat-radio-button 
        *ngFor="let option of config.options" 
        [value]="option.value"
        class="radio-option">
        {{ option.label }}
      </mat-radio-button>
  </mat-radio-group>
  <!-- Mensagem de erro -->
  <mat-error *ngIf="group.get(config.name)?.invalid && group.get(config.name)?.touched">
     Este campo é obrigatório.
  </mat-error>
</div> 